import React, { useState } from "react";
import "../../assets/css/contact.css";
import { useInView } from "react-intersection-observer";
import "animate.css";
import emailjs from "emailjs-com";
import { FaFacebook, FaInstagram } from "react-icons/fa";
const ContactUs = () => {
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs
      .sendForm(
        "service_2cnqd96", // Replace with your EmailJS service ID
        "template_za2q9e9", // Replace with your EmailJS template ID
        e.target,
        "nQBJzdhm_0rQ4QbLv" // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          console.log(result.text);
          setFormSubmitted(true);
          setErrorMessage("");
          e.target.reset();
        },
        (error) => {
          console.error(error.text);
          setErrorMessage(
            "An error occurred while sending your message. Please try again."
          );
        }
      )
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div ref={ref} className="container mt-5" id="contact">
      <h1
        className={`text-center fs-70 mb-5 mt-5 py-3 border-2 border-dark border-top border-bottom`}
      >
        <div
          className={`${
            inView
              ? "animate__animated animate__zoomIn"
              : "animate__animated animate__zoomOut"
          }`}
        >
          <span className="text-dark">Crafting</span>
          <span className="text-yellow"> smiles </span>
          <span className="text-dark">with clear</span>
          <span className="text-yellow"> aligners </span>
        </div>
      </h1>
      <div> </div>
      <div className="row mt-5 ">
        <div className="col-lg-6">
          <div className="position-relative line-wala">
            <h2 className="text-center fs-40 text-yellow">
              We’re Here To <span className="text-dark">help</span>
            </h2>
            <p className="fs-22 text-md-start text-center">
              If you&apos;re not sure about anything and want to reach out to
              get more informaton then just drop us a message and one of the
              team will get in touch.
            </p>
            <div className="d-md-flex d-none flex-row gap-2">
              <span className="" style={{ fontSize: "20px" }}>
                <i class="fa fa-map-marker" aria-hidden="true"></i>
              </span>
              <p className="fs-18">
                43 Berkeley Square,
                <br />
                London,
                <br />
                W1J 5AP
              </p>
            </div>
            <a
              className="text-black d-flex justify-content-md-start justify-content-center gap-2 fs-18 mb-4"
              href="mailto:info@alignar.com"
            >
              <span>
                <i class="fa fa-envelope"></i>
              </span>
              info@alignar.com
            </a>

            <h3 className="text-md-start follow-us-heading text-center">
              Follow us on social media
            </h3>
            <div className="mt-md-4 d-flex justify-content-md-start justify-content-center">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon "
              >
                <FaFacebook color="#000000" />
              </a>
              <a
                href="https://www.instagram.com/alignars/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              >
                <FaInstagram color="#000000" />
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 px-lg-5 pt-lg-0 pt-3 px-3 pb-4 pb-md-0">
          <h1
            className={`text-yellow text-center fs-40  ${
              inView
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__zoomOut"
            }`}
          >
            Find The Nearest <span className="text-dark">Provider.</span>
          </h1>
          <p
            className={`fs-22 fw-400 text-center ${
              inView
                ? "animate__animated animate__fadeIn"
                : "animate__animated animate__fadeOut"
            }`}
          >
            Share a few details and we’ll get in touch with the nearest clinic
            where you can have your smile transformed.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <input
                type="text"
                name="name"
                className="form-control border-0"
                id="name"
                placeholder="Name"
                required
              />
              <hr />
            </div>
            <div className="mb-2">
              <input
                type="email"
                name="email"
                className="form-control border-0"
                id="email"
                placeholder="Email"
                required
              />
              <hr />
            </div>
            <div className="mb-2">
              <input
                type="text"
                name="number"
                className="form-control border-0"
                id="postal-code"
                placeholder="Phone Number"
                pattern="\d{11}"
                title="Phone number must be 11 digits"
                required
              />
              <hr />
            </div>
            <div className="mb-2">
              <input
                type="text"
                name="postal_code"
                className="form-control border-0"
                id="postal-code"
                placeholder="Postcode"
                required
              />
              <hr />
            </div>
            <div className="mb-2">
              <textarea
                name="message"
                className="form-control border-0"
                id="message"
                rows="3"
                placeholder="Message"
                required
              ></textarea>
              <hr />
            </div>
            <div className="mb-2 form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="terms"
                required
              />
              <label className="form-check-label fs-14" htmlFor="terms">
                I consent to my personal data being collected and stored as per
                the{" "}
                <a className="text-yellow" href="#" target="_blank">
                  Privacy Policy
                </a>
                .
              </label>
            </div>
            <button
              type="submit"
              className="btn-theme w-100 mt-3"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>
          </form>

          {errorMessage && <p className="text-danger mt-3">{errorMessage}</p>}
        </div>
      </div>

      {formSubmitted && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setFormSubmitted(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body bg-theme p-4 text-center">
                <p className="fs-20">
                  <span className="text-golden">Thank you</span> for getting in
                  touch, one of the team will be in touch soon!
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
